var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bod-archives"}},[_vm._v("bod archives")])}
var staticRenderFns = []

export { render, staticRenderFns }